<template>
  <div>
    <div :class="maxWidth ? 'select-box ajustar' : 'select-box'">
      <div :class="active ? 'active' : ''" class="options-container">
        <div class="option" v-for="item in items" :key="item.value" @click="handleSelect(item)">
          <input type="radio" class="radio" :id="item.value" name="category" />
          <label  class="label" :class="item.text">{{
            item.text
          }}</label>
        </div>
      </div>
      <div class="input-container">
        <input
          type="text"
          :placeholder="placeholder"
          @click="handleActive"
          class="selected"
          v-model="busqueda"
        />
        <p v-if="show" @click="resetSearch" class="reset-search">X</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [{ value: -1, text: "Busque un cliente" }],
    },
    placeholder: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["busqueda","id"],
  data() {
    return {
      active: false,
      selectedItem: { value: 0, text: "" },
      busqueda: "",
      timer: null,
      show:false
    };
  },
  methods: {
    resetSearch() {
      this.busqueda = "";
      this.show = false
      this.$emit("id", "");
    },
    handleActive() {
      this.active = !this.active;
    },
    handleSelect(item) {
      if (item.value < 0) return;
      this.show = true
      this.busqueda = item.text;
      this.active = false;
      this.$emit("id", item.value);
    },
  },
  watch: {
    selectedItem(value) {
      console.log(value);
    },
    busqueda(value) {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        this.$emit("busqueda", value);
      }, 1000);
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  box-sizing: border-box;
}

.input-container {
  position: relative;
}

.label{
  width: 100%;
}

.reset-search {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 800;
  cursor: pointer;
  color: #ddd;
  width: 11px;
  height: 9px;
  font-weight: 700;
}

.select-box {
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  width: 140px;
  /* overflow: hidden; */
  text-overflow: ellipsis;
  position: relative;
}

.select-box.ajustar {
  width: 100% !important;
}

.input-crearCita {
  width: 100%;
  margin-bottom: 43px;
  height: 40px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  background-image: url("../../assets/imgs/Buscar.svg");
  background-size: 17px;
  background-position-y: center;
  background-position-x: 10px;
  outline: none;
  padding-left: 33px;
}
.input-crearCita::placeholder {
  opacity: 0.5;
}
.select-box .options-container {
  background-color: #ffff;
  border: 1px solid #0a4f9c;
  max-height: 0;
  width: 100%;
  opacity: 0;
  transition: all 0.4s;
  border-radius: 4px;
  overflow: hidden;
  order: 1;
  position: absolute;
  top: 40px;
  z-index: 700;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #70707021;
}

.selected {
  width: 100%;
  background-color: #ffff;
  outline: none;
  /* border: 1px solid #0a4f9c; */
  border-radius: 4px;
  /* margin-bottom: 4px; */
  color: #0a4f9c;
  order: 0;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  /* z-index: 600; */
  text-align: start;
}

.selected::after {
  content: "";
  background-image: url("../../assets/imgs/Arrow.svg");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  height: 100%;
  width: 15px;
  top: 10px;
  right: 10px;
  transition: all 0.4s;
}

.select-box .option,
.selected {
  padding: 4px 8px;
  cursor: pointer;
  width: 100%;
}

/* .selected + .options-container.active{
      border-bottom: none;
  } */

.select-box .options-container.active {
  max-height: 240px;
  opacity: 1;
  overflow-y: scroll;
  /* border-top: none; */
}

.select-box .options-container.active + .selected::after {
  transform: rotateX(180deg);
  top: -10px;
}

/* .select-box .options-container::-webkit-scrollbar {
    width: 8px;
    background-color: #0d141f;
    border-radius: 0 8px 8px 0;
  }
  
  .select-box .options-container::-webkit-scrollbar-thumb {
    background-color: #525861;
    border-radius: 0 8px 8px 0;
  } */

.select-box .option:hover {
  background-color: #e5e5e5;
}

.select-box label {
  cursor: pointer;
}

.select-box .option .radio {
  display: none;
}
</style>
